/*
 * Authors: mariushirjanu
 * Created: 07/11/2022
 */
import { Component, OnInit, OnDestroy } from '@angular/core';
import { TransitionService, Transition } from '@uirouter/angular';
import { TranslationHelperService } from '../translation/translation-helper.service';

// this component is usable when it is only necessary to have a component that only has ui-view; it also fixes the translation issues when the transition change
@Component({
  selector: 'uiview',
  template: '<ui-view></ui-view>'
})
export class UiViewComponent implements OnInit, OnDestroy {
  private removeOnStateSuccessListener:Function;

  constructor(
    private translationHelperService: TranslationHelperService,
    private transitionService:TransitionService
  ) {
    /***/
  }

  public ngOnInit():void {
    this.listen();
  }

  private listen(){
    // reload translation on every state param changed
    this.removeOnStateSuccessListener = this.transitionService.onSuccess({}, this.reloadTranslation);
  }

  private reloadTranslation = (transition:Transition):void => {
    this.translationHelperService.loadTranslations(transition.to().data); // this.stateService.current.data
  };

  public ngOnDestroy():void {
    this.removeOnStateSuccessListener();
  }
}